import { getTrackingHeadersMap } from "./getTrackingHeaders";
import axios from "./httpClient";
import { ApiType } from "./Types";
import { getUrl } from "./getURL";
import { ErrorMessages } from "../constants";
import { throwApiError } from "./apiError";
import { getTerminalId } from "../helpers";

export interface MisdeliveryBolUpdatePayload {
  pickupNumber?: number;
  pickupBusinessName?: string;
  pickupAddress1?: string;
  pickupCity?: string;
  pickupState?: string;
  pickupZip?: string;
  pickupContactName?: string;
  freightDescription?: string;
  isMisdeliveryHazmat?: string;
  unNumber?: string;
  totalPiecesMisdelivered?: number;
  weight?: number;
}

export const UpdateMisdeliveryBol = async (
  osdNumber: string | number,
  params: MisdeliveryBolUpdatePayload,
) => {
  try {
    const osdNumberStr = (osdNumber ?? "").toString().trim();
    const url = getUrl(ApiType.MISDELIVERY_BOL).replace(
      ":osdNumber",
      encodeURIComponent(osdNumberStr),
    );
    // Get static headers from map (do not use || {})
    const staticHeaders = getTrackingHeadersMap(ApiType.MISDELIVERY_BOL);
    // Add dynamic values
    const headers = {
      ...staticHeaders,
      "OSD-Exception-Number": osdNumberStr,
      "OSD-Pickup-Terminal": getTerminalId(),
    };
    const { data } = await axios.put(url, params, { headers });
    return data;
  } catch (error: any) {
    return throwApiError(error, ErrorMessages.misdeliveryBolCreateError, {
      badRequestOrder: "errorsFirst",
    });
  }
};
